import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import Logo from "../../components/Logo";

export default function AdminForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="min-h-screen bg-[#FFF7FB] flex items-center justify-center px-4 py-16" data-testid="admin-forgot-password-page">
            <div className="w-full max-w-md bg-white border border-blush/20 p-8 md:p-10 shadow-[0_30px_80px_rgba(236,0,140,0.15)]">
                <Link to="/" className="block mb-6">
                    <Logo variant="dark" className="h-12 mx-auto" />
                </Link>
                <h1 className="font-display text-3xl text-ink mb-2 text-center">Reset Password</h1>
                <p className="text-sm text-ink-soft mb-8 text-center">Cake Central CMS</p>

                {sent ? (
                    <div className="text-center">
                        <p className="text-sm text-ink mb-6">
                            If <strong>{email}</strong> has an admin account, we've sent a password reset link to it. Check your inbox.
                        </p>
                        <Link to="/admin/login" className="text-xs tracking-[0.2em] uppercase text-blush hover:underline">
                            Back to login
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-5">
                        <div>
                            <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Email</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 border border-[#EAE3DE] focus:outline-none focus:border-blush"
                                data-testid="forgot-password-email"
                            />
                        </div>
                        <button type="submit" disabled={loading} className="btn-pink w-full disabled:opacity-60" data-testid="forgot-password-submit">
                            {loading ? "Sending…" : "Send reset link"}
                        </button>
                        <p className="text-center">
                            <Link to="/admin/login" className="text-xs tracking-[0.2em] uppercase text-ink-soft hover:text-blush">
                                Back to login
                            </Link>
                        </p>
                    </form>
                )}
            </div>
        </main>
    );
}
